import React, { memo, MouseEventHandler, ReactElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Row from '../../../components/connectedForm/Row';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

const Div: any = styled.div<{ hasDescription: boolean; align: 'right' | 'left' }>`
  display: inline-block;
  background-color: ${p4Tokens.colorNeutralBackground1};
  padding: 0;
  color: ${(props) => props.theme.colors.formHeading};
  margin: ${(props) => (props.hasDescription ? '0.3rem 0 0 0' : '0.3rem 0 0.5rem 0')};
  font-weight: 400;
  font-size: 13px;
  padding-top: 15px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  text-align: ${(props) => (props.align === 'right' ? 'right' : 'left')};
  text-transform: uppercase;
  letter-spacing: -0.25px;
`;

const ContainerDiv = styled.div`
  box-sizing: border-box;
  flex: 0 0 auto;
  padding-right: ${(props) => props.theme.grid.gutterWidth};
  padding-left: ${(props) => props.theme.grid.gutterWidth};
  flex-basis: 100%;
  max-width: 100%;
`;

const DescriptionDiv = styled.label`
  display: inline-block;
  width: 100%;
  margin: 0;
  font-size: 11px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.inputLabel};
  padding-bottom: 0.4rem;
`;

type ILegendProps = {
  align?: 'right' | 'left';
  description?: string;
  label: string | ReactElement;
  style?: React.CSSProperties; //Consider deprecated, use 'styles' instead.
  styles?: {
    root?: React.CSSProperties;
    container?: React.CSSProperties;
    labelWrapper?: React.CSSProperties;
  };
  legendActionVisible?: boolean;
  legendAction?: MouseEventHandler;
};

const VertElipIcon = ({ onClick }: { onClick?: MouseEventHandler }) => {
  return (
    <span onClick={onClick} style={{ position: 'absolute', right: '0', top: '15px' }} className="Select-arrow-zone">
      <div className="icon">more_vert</div>
    </span>
  );
};

const Legend = ({
  style,
  align,
  description,
  label,
  legendAction,
  styles = { root: {}, container: {}, labelWrapper: {} },
  legendActionVisible,
}: ILegendProps) => {
  return (
    <Row style={styles.root}>
      <ContainerDiv style={styles.container || style}>
        <Div align={align} hasDescription={!!description} style={styles.labelWrapper}>
          {label}
        </Div>
        {description ? <DescriptionDiv>{description}</DescriptionDiv> : null}
        {legendActionVisible && <VertElipIcon onClick={legendAction} />}
      </ContainerDiv>
    </Row>
  );
};

Legend.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  style: PropTypes.any,
};
Legend.defaultProps = {
  label: '',
};

export default memo(Legend);
